import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import '../styles/index.css';
import '../styles/root.css';

// FOR THE FUTURE:
// INTERSECTION OBSERVER THAT CHANGES THE BLEND MODE OF THE IMAGES ON SCROLL ??
// LOCATION — IDK
// FLOWERS HAVE A DIFFERENT SCROLL SPEED 

export default function Root() {
  
  const imgs = [
    "img-02.jpg","img-2.jpg","img-8.jpg","img-03.jpg","img-46.jpg",
    "img-04.jpg","img-05.jpg","img-4.jpg","img-9.jpg","img-29.jpg",
    "img-47.jpg","img-17.jpg","img-23.jpg","img-24.jpg","img-16.jpg"
  ];
  const flowers = [
    "1.png","2.png","3.png","4.png",
    "5.png","6.png","7.png","8.png"
  ];

  let landingImgs;
  var num = 0;
  var imgTop = 15;
  var imgLeft = 15;
  var transTop = 0;
  var transLeft = 0;
  var imgHeight = 100;
  var flowerTop = 10;
  var flowerLeft = 10;

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  useEffect(() => {
    landingImgs = document.getElementsByClassName("landing-img");
    if (landingImgs) {
      for (let i = 0; i < landingImgs.length; i++) {
        imgHeight = getRandomInt(20,70);
        transTop = getRandomInt(10,50);
        transLeft = getRandomInt(-30,120);
        landingImgs[i].style.height = imgHeight + "vh";
        landingImgs[i].style.top = imgTop + "%";
        landingImgs[i].style.left = imgLeft + "%";
        landingImgs[i].style.transform = "translateY(" + transTop + "%)";
        landingImgs[i].style.transform = "translateX(" + transLeft + "%)";
        imgTop += 20;
      }
    }
  })

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((open) => !open);
  } 
  
  return(
    <div id="container">
      <div className="root-header">
        <p>Hello! I'm Sammy. I am also the (ee • ray) in <em>erye.film</em>. I've carried an affinity for people first, and colours second.</p>
        <p>Press or click <span id="root-here" onClick={toggleMenu}>here</span> to see more about my world.</p>
      </div>
      <ul className={`root-menu ${isOpen ? 'open' : ''}`}>
          <a href={`/archive`}>
            <li className="root-menu-item">&nbsp;ARCHIVE&nbsp;</li>
          </a>
          <a href={`/info`}>
              <li className="root-menu-item">&nbsp;PRICING&nbsp;</li>
          </a>
          <a href={`/about`}>
            <li className="root-menu-item">&nbsp;ABOUT&nbsp;</li>
          </a>
          <a href={`/faq`}>
            <li className="root-menu-item">&nbsp;FAQ&nbsp;</li>
          </a>
          <a href={`/contact`}>
            <li className="root-menu-item">&nbsp;CONTACT&nbsp;</li>
          </a>
      </ul>
      <div id="landing" >
        {imgs.map((elt) => {
          flowerTop = getRandomInt(10,90);
          flowerLeft = getRandomInt(10,90);
          num += 1;
          return (
            <div>
                <img
                  src={require('/public/compressed/' + elt)}
                  className={`landing-img`}
                />
            </div>
          );
        })}
      </div>
    </div>
  );
}